export default __webpack_public_path__ + "static/media/Paula.6ff60f83.jpg";